import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_logo-express",
  "use": "svg_logo-express-usage",
  "viewBox": "0 0 42 70",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 42 70\" id=\"svg_logo-express\"><path d=\"M0 70V0h42v8.2H9.5v21.3h28v8h-28v24.3H42V70H0Z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol